import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';

/**
 * Maintenance merchandisers list (PD-13938) — units with status =
 * maintenance. Mirrors the vehicle status tabs (filterRules default on the
 * status filter).
 */
export const maintenanceMerchandisersList: ListBuilderList = {
	id: 'default-merchandisers-maintenance',
	name: 'Maintenance',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		merchandiserStatus: {
			defaultValue: [{ id: 'maintenance', label: 'Maintenance' }],
		},
	},
	columns: createMerchandiserColumns(),
	defaultSortId: 'merchandiser-name',
	sortOrder: 2,
};
